(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[301],{

/***/ "0Gyk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowLeft", function() { return ArrowLeft; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ArrowLeft = function ArrowLeft(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M8.58101035,16.4135055 C8.20528502,16.0391321 8,15.5400357 8,15.0120627 C8,14.4791745 8.20528502,13.9823309 8.58101035,13.6079575 L18.609711,3.58320747 C18.9854363,3.20641739 19.4824212,3 20.0144499,3 C20.5440892,3 21.0434634,3.20641739 21.4167994,3.58320747 C21.7923256,3.95760139 22,4.45440396 22,4.98712835 C22,5.5151014 21.7923256,6.01440252 21.4167994,6.38877596 L12.7902492,15.0120627 L21.4167994,23.632687 C21.7923256,24.0070605 22,24.5063616 22,25.0367922 C22,25.5647653 21.7923256,26.0638616 21.4167994,26.4384398 C20.6677381,27.1871867 19.3609626,27.1871867 18.609711,26.4384398 L8.58101035,16.4135055 Z"
  }));
};

/***/ })

}]);